<template>
  <RakutenCarouselStep
    v-if="hasPartnerPromoCode(partnerPromoCodes, 'RAKUTEN')"
    :category
    class="my-72 md:my-36"
    :model
    :without-left-template
  />
</template>

<script setup lang="ts">
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import { hasPartnerPromoCode } from '~/scopes/product-core/utils/hasPartnerPromoCode/hasPartnerPromoCode'

import RakutenCarouselStep from './components/RakutenCarouselStep/RakutenCarouselStep.vue'

defineProps<{
  category?: string
  model?: string
  partnerPromoCodes: GetProductResponse['includedServiceOffers']['partnerPromoCodes']
  withoutLeftTemplate?: boolean
}>()
</script>
